<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.general.title") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-row>
        <v-col cols="12" lg="6">
          <v-form ref="generalParamsForm">
            <v-select
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                :label="$t('common.currency')"
                :items="currencies"
                outlined
                item-text="name"
                item-value="id"
                class="pointer"
                :loading="isLoadingCurrencies"
                :disabled="isLoadingCurrencies"
                v-model="shopTemp.currency_id"
            ></v-select>
            <v-text-field
              v-model="shopTemp.legal_name"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="shopTemp.legal_name"
              :label="$t('common.legal_name')"
              outlined
            ></v-text-field>

            <v-text-field
                v-model="shopTemp.head_position"
                :value="shopTemp.head_position"
                :label="$t('viewShops.head_position')"
                outlined
            ></v-text-field>

            <v-text-field
                v-model="shopTemp.head_name"
                :value="shopTemp.head_name"
                :label="$t('viewShops.head_name')"
                outlined
            ></v-text-field>

            <v-text-field
                v-model="shopTemp.legal_address"
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                :value="shopTemp.legal_address"
                :label="$t('viewShops.legal_address')"
                outlined
            ></v-text-field>

            <v-text-field
              v-model="shopTemp.fact_address"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="shopTemp.fact_address"
              :label="$t('viewShops.fact_address')"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="shopTemp.phone"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="shopTemp.phone"
              :label="$t('viewShops.phone')"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="shopTemp.site"
              :value="shopTemp.site"
              :label="$t('viewShops.site')"
              outlined
            ></v-text-field>
            <img :src="backendURL+shopTemp.logo" v-if="shopTemp.logo" style="max-height: 50px;"/>
            <v-file-input
                :key="componentKey"
                :disabled="savingInProgress"
                accept=".svg,.png,.jpg,.gif,.jpeg"
                :label="shopTemp.logo ? $t('viewShops.replace_logo') : $t('viewShops.logo')"
                @change="uploadLogo($event)"
                outlined
            ></v-file-input>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="fillShopTemp"
              @keyup.enter="fillShopTemp"
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5"
              color="primary"
              elevation="0"
              @click="submit"
              @keyup.enter="submit"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonMixin from "@/mixins/common";
export default {
  mixins: [CommonMixin],
  data: () => ({
    componentKey: 0,
    shopTemp: {
      legal_name: null,

      inn: null,
      kpp: null,
      okpo: null,
      ogrn: null,
      head_position: null,
      head_name: null,

      legal_address: null,
      fact_address: null,
      phone: null,
      site: null,
      logo: null,
      logoFile: {filename: null, extension: null, file:null}
    },
  }),
  created() {
    this.fillShopTemp();
    this.getCurrencies();
  },
  computed: {
    ...mapState("common", ["currencies", "isLoadingCurrencies"]),
    ...mapState("auth", ["authenticatedUser", "isFetching"]),
    ...mapState("shops", ["savingInProgress"]),
  },
  watch: {},
  methods: {
    submit() {
      if (this.$refs["generalParamsForm"].validate()) {
        this.shopTemp.id = this.authenticatedUser.shop.id;
        this.$store.dispatch("shops/update", this.shopTemp).then((res)=>{
          if(res)this.componentKey++;
        })
      }
    },
    getCurrencies() {
      this.$store.dispatch("common/currenciesGet")
    },
    fillShopTemp() {
      this.shopTemp.legal_name = this.authenticatedUser.shop.legal_name;
      this.shopTemp.legal_address = this.authenticatedUser.shop.legal_address;
      this.shopTemp.fact_address = this.authenticatedUser.shop.fact_address;
      this.shopTemp.phone = this.authenticatedUser.shop.phone;
      this.shopTemp.site = this.authenticatedUser.shop.site;

      this.shopTemp.inn = this.authenticatedUser.shop.inn;
      this.shopTemp.kpp = this.authenticatedUser.shop.kpp;
      this.shopTemp.okpo = this.authenticatedUser.shop.okpo;
      this.shopTemp.ogrn = this.authenticatedUser.shop.ogrn;
      this.shopTemp.head_position = this.authenticatedUser.shop.head_position;
      this.shopTemp.head_name = this.authenticatedUser.shop.head_name;
      this.shopTemp.currency_id = this.authenticatedUser.shop.currency_id;

      this.shopTemp.logo = this.authenticatedUser.shop.logo;
    },
    uploadLogo(file){
      if(file){
        if(file.name){
          this.shopTemp.logoFile.filename = file.name;
          this.shopTemp.logoFile.extension = file.name.split('.').pop();
        }
      } else {
        this.shopTemp.logoFile.filename = null;
        this.shopTemp.logoFile.extension = null;
      }
      this.shopTemp.logoFile.file = file;
    },
  },
};
</script>

<style scoped></style>
